import React from 'react';
import classes from './styles/Hero.module.css';
import Form from './Form';

export default function Hero() {
  return (
    <div className={classes.container}>
      <div className={classes.imageText}>
        <iframe
          title="D'ClimaFresh Sanitización"
          width="560"
          height="315"
          src="https://www.youtube.com/embed/hyJkOaV03b8"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
      <div className={classes.formContainer}>
        <Form />
      </div>
    </div>
  );
}
